var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner'),_c('Partner'),_c('Solutions'),_c('About'),_c('Services'),_c('Funfacts'),_c('Projects'),_c('Pricing'),_c('Feedback'),_c('Blog'),_c('Trial')],1)}
var staticRenderFns = []

export { render, staticRenderFns }